import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=677f8bc2&scoped=true&"
import script from "./Statuses.vue?vue&type=script&lang=ts&"
export * from "./Statuses.vue?vue&type=script&lang=ts&"
import style0 from "./Statuses.vue?vue&type=style&index=0&id=677f8bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f8bc2",
  null
  
)

export default component.exports